<ngx-page-container>
  <nb-card class="filter">
    <nb-card-body>
      <div class="row">
        <div class="col-6">
          <div *ngIf="regions">
            <h5>Regions</h5>
            <ss-multiselect-dropdown
              (ngModelChange)="loadReport()"
              [options]="regions"
              [settings]="{ itemClasses: 'ss-multiselect-items' }"
              [(ngModel)]="filter.regions"></ss-multiselect-dropdown>

          </div>
          <div *ngIf="contacts">
            <h5>Region Sales Manager</h5>
            <ss-multiselect-dropdown
              (ngModelChange)="loadReport()"
              [options]="contacts"
              [(ngModel)]="filter.rsms"></ss-multiselect-dropdown>
          </div>
          <div *ngIf="customers">
            <h5>Customers</h5>
            <ss-multiselect-dropdown
              (ngModelChange)="loadReport()"
              [options]="customers"
              [(ngModel)]="filter.customers"></ss-multiselect-dropdown>
          </div>
        </div>


        <div class="col-6">
          <!--<div *ngIf="regions">
            <h5>Business Unit</h5>
            <ss-multiselect-dropdown
              (ngModelChange)="loadReport()"
              [options]="businessUnits"
              [(ngModel)]="filter.bus"></ss-multiselect-dropdown>

          </div>-->
          <ngx-form-date [(value)]="filter.dateFrom" title="Date from" (valueChange)="loadReport()"></ngx-form-date>
          <ngx-form-date [(value)]="filter.dateTo" title="Date to" (valueChange)="loadReport()"></ngx-form-date>
          <!--<h5>Activity Types</h5>
          <ss-multiselect-dropdown
            (ngModelChange)="loadReport()"
            [options]="activityTypes"
            [(ngModel)]="filter.activitytypes"></ss-multiselect-dropdown>-->
        </div>
      </div>
    </nb-card-body>
  </nb-card>
  <a [routerLink]="[]" (click)="downloadPdf()">Generate PDF</a>
</ngx-page-container>
